import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Slider from 'react-slick';
import { AppTheme } from '../styles/AppTheme';
import { ProductTile } from '../components/ProductTile';
import { AppHelper } from '../helpers/AppHelper';
import { Link } from 'react-router-dom';

export class Carousel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data || this.props.data.length === 0) {
      return (
        <div className={css(Styles.emptyView)}>
          <p className={css(Styles.emptyViewMsg)}>Nothing to show</p>
        </div>
      )
    }

    const items = AppHelper.sortParamsByOrder(this.props.data)
    return (
      <Slider
        {...this.props.settings}
        className={css(Styles.sliderContainer)}>
        {items.length > 0 &&
          items.map((item, index) => {
            return (
              <Link
                key={index}
                className={css(Styles.link)}
                to={'/products/' + item.slug}>
                <ProductTile
                  key={index}
                  item={item}
                  home={true}
                  equipment={this.props.equipment} />
              </Link>
            )
          })
        }
      </Slider >
    );
  }
}


const Styles = StyleSheet.create({
  sliderContainer: {
    display: 'flex',
    width: '100%',
    padding: 10,
  },
  emptyView: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyViewMsg: {
    color: AppTheme.primaryColor
  },
  link: {
    textDecoration: 'none',
  }
})


// WEBPACK FOOTER //
// ./src/components/Carousel.js